import React, { Component } from 'react';
import Image from 'next/image';
import { Modal, List, Row, Col } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import { timerFormat } from '../../utils/utils';

import defaultImg from '../../public/images/hidream-admin-bg.jpg';

export class VideoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentVideoSrc: {},
      delModelVisible: [],
    };
  }

  showModal = (item) => {
    const delModelVisible = this.state.delModelVisible;
    delModelVisible[item.title] = true;

    this.setState({
      currentVideoSrc: item.videoSrc,
      delModelVisible,
    });
  };

  handleCancel = () => {
    this.setState({
      delModelVisible: [],
    });
  };

  render() {
    const { delModelVisible, currentVideoSrc } = this.state;
    const { videoData } = this.props;

    videoData.forEach((item) => {
      item.videoSrc = {
        poster: item.src
          ? `https://cdn-storage.hidream.net/${item.src}`
          : defaultImg,
        src: item.video_url,
      };
    });

    return (
      <List
        className="videoList"
        itemLayout="vertical"
        pagination={false}
        dataSource={videoData}
        renderItem={(item) => (
          <List.Item key={item.title} className="listItem">
            <div className="listImg">
              <Image
                src={
                  item.src
                    ? `https://cdn-storage.hidream.net/${item.src}`
                    : defaultImg
                }
                alt={item.title}
                width={750}
                height={442}
              />
              <span
                className="play"
                onClick={() => {
                  this.showModal(item);
                }}
              >
                <CaretRightOutlined />
              </span>
            </div>

            <div className="listContent">
              <div className="header">
                <div
                  className="title"
                  onClick={() => {
                    this.showModal(item);
                  }}
                >
                  {item.title}
                </div>
                <p
                  className="description"
                  onClick={() => {
                    this.showModal(item);
                  }}
                >
                  {item.description ? item.description : ''}
                </p>
              </div>

              <Row justify="space-between" align="middle">
                <Col className="origin">
                  <div className="img">
                    <Image
                      src={require('../../public/images/hi.png').default}
                      alt="Hidream"
                    />
                  </div>
                  讯梦国际
                </Col>
                <Col className="time">
                  {item.updated_at
                    ? timerFormat(item.updated_at)
                    : item.updated_at}
                </Col>
              </Row>
            </div>

            {delModelVisible[item.title] ? (
              <Modal
                title="视频预览"
                visible={delModelVisible[item.title]}
                onCancel={this.handleCancel}
                destroyOnClose
                maskClosable={true}
                footer={null}
                className="videoModal"
                centered
              >
                <Player
                  playsInline
                  poster={currentVideoSrc.poster}
                  src={currentVideoSrc.src}
                  fluid={false}
                  width="auto"
                  height={400}
                >
                  <ControlBar autoHide={false} disableDefaultControls={false} />
                  <BigPlayButton position="center" />
                </Player>
              </Modal>
            ) : null}
          </List.Item>
        )}
      />
    );
  }
}

export default VideoList;
